import { createStore } from 'vuex'

export default createStore({
  state: {
    isDarkMode: JSON.parse(localStorage.getItem('darkMode') || 'false'),
    leagueData: [],
    teams: null,
    bereiche: null,
    ligenJSON: null,
    playersToCompare: [] // Neue Zustandsvariable für Spielervergleich
  },
  getters: {
    hasPlayersToCompare: state => state.playersToCompare.length > 0,
    playersToCompareCount: state => state.playersToCompare.length
  },
  mutations: {
    toggleDarkMode(state) {
      state.isDarkMode = !state.isDarkMode;
      localStorage.setItem('darkMode', JSON.stringify(state.isDarkMode));
    },
    setleagueData(state, data) {
      state.leagueData = data;
    },
    setTeams(state, data) {
      state.teams = data;
    },
    setBereiche(state, data) {
      state.bereiche = data;
    },
    setLigenJSON(state, data) {
      state.ligenJSON = data;
    },
    // Neue Mutations für den Spielervergleich
    addPlayerToCompare(state, player) {
      // Prüfen ob der Spieler bereits in der Liste ist
      const playerExists = state.playersToCompare.some(p => p.display_name === player.display_name);
      if (!playerExists && state.playersToCompare.length < 10) { // Maximal 4 Spieler zum Vergleich
        state.playersToCompare.push(player);
      }
    },
    removePlayerFromCompare(state, playerName) {
      state.playersToCompare = state.playersToCompare.filter(p => p.display_name !== playerName);
    },
    clearPlayersToCompare(state) {
      state.playersToCompare = [];
    }
  },
  actions: {
  },
  modules: {
  }
})
